module.exports = __webpack_public_path__ + "img/mag-live.a76873ce.png";